import React from "react";
import "./style.css";
export default function Validation({ className, children }) {
  return (
    <div className={`validation validation--${className}`}>{children}</div>
  );
}
